module.exports = __webpack_public_path__ + "img/cf4bb75.jpg";